// #standard page 
import React, { Component } from 'react';

//#table
import GenericTable from '../../components/GenericTable';
import { dateFormat, currencyFormat } from '../../helpers/formatter';

//#form
import { Card, CardBody } from 'reactstrap';

//#other
import { fetchJSON } from '../../helpers/api';

import SuppRentDetails from './SuppRentDetails';


const columns = [
    {
        dataField: 'invoiceNo',
        text: 'Invoice No.',
        sort: true
    },
    {
        dataField: 'dueDate',
        text: 'Due Date',
        sort: true,
        formatter: dateFormat
    },
    {
        dataField: 'description',
        text: 'Description',
        sort: true
    },
    {
        dataField: 'amount',
        text: 'Amount',
        sort: true,
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'outstandingBalance',
        text: 'Outstanding Balance',
        sort: true,
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    }
];

const defaultSorted = [
    {
        dataField: 'dueDate',
        order: 'desc',
    },
];



class SuppRentView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
        };
    }

    expandRow = {
        renderer: invoice => (
            <SuppRentDetails leaseNo={this.props.leaseNo} invoiceNo={invoice.invoiceNo} />
        ),
    };

    componentDidMount = () => {
        this.loadSuppRentInvoices(this.props.leaseNo);
    };

    async loadSuppRentInvoices(leaseNo) {
        let url = `/portal/LeaseAccount/GetSuppRentInvoices?leaseNo=${leaseNo}`;
        let response = await fetchJSON(url);
        this.setState({
            data: response.data,
            loading: response.loading
        });
    }

    render() {
        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <GenericTable
                            columns={columns}
                            data={this.state.data}
                            keyField='invoiceNo'
                            defaultSorted={defaultSorted}
                            loading={this.state.loading}
                            expandRow={this.expandRow}
                        />
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
};


export default SuppRentView;